import Picture from "./picture.marko";
import Icon from "./icon.marko";

<!--
  The end of a module, on its bonus story's done screen (page-data.js moduleSummary): praise,
  what the learner can do now, the module's numbers with their share of the whole course, its
  grammar, the body (the module's PDFs), and how far into the course the learner is.
-->
<const/m=input.summary/>
<const/copy=input.copy/>
<const/fill=(text, values) => Object.entries(values).reduce((out, [key, value]) => out.replaceAll(`{${key}}`, String(value)), String(text || ""))/>
<const/share=(part, whole) => `${Math.max(3, Math.round((100 * part) / Math.max(whole, 1)))}%`/>
<section class="ll-module-done">
  <div class="ll-module-done__confetti" aria-hidden="true">
    <for|i| from=1 to=14><i style=`--i:${i}`></i></for>
  </div>
  <p class="ll-course-kicker ll-course-kicker--ok">${fill(copy.moduleComplete, { n: m.n })} · ${m.title}</p>
  <h1 class="ll-module-done__title">${copy.moduleWellDone}</h1>
  <if=m.goal>
    <p class="ll-module-done__goal">${m.goal}</p>
  </if>

  <div class="ll-module-done__stats">
    <div class="ll-module-done__stat">
      <strong>${m.scenes.length}</strong><span>${copy.scenesCount}</span>
      <span class="ll-module-done__dots" aria-hidden="true"><for|scene| of=m.scenes><i></i></for></span>
    </div>
    <div class="ll-module-done__stat">
      <strong>${m.words.module}</strong><span>${copy.newWords}</span>
      <span class="ll-module-done__bar" title=fill(copy.ofCourse, { n: m.words.done, total: m.words.course }) aria-hidden="true"><i style=`width:${share(m.words.done, m.words.course)}`></i></span>
    </div>
    <div class="ll-module-done__stat">
      <strong>${m.sentences.module}</strong><span>${copy.sentencesCount}</span>
      <span class="ll-module-done__bar" title=fill(copy.ofCourse, { n: m.sentences.done, total: m.sentences.course }) aria-hidden="true"><i style=`width:${share(m.sentences.done, m.sentences.course)}`></i></span>
    </div>
    <div class="ll-module-done__stat">
      <strong>${m.grammar.length}</strong><span>${copy.grammarPointsCount}</span>
      <span class="ll-module-done__dots ll-module-done__dots--small" aria-hidden="true"><for|point| of=m.grammar><i></i></for></span>
    </div>
  </div>

  <h2 class="ll-module-done__head">${copy.youCanNow}</h2>
  <ul class="ll-module-done__cando">
    <for|scene| of=m.scenes>
      <li>
        <Picture image=scene.art class="ll-module-done__thumb" alt=""/>
        <span class="ll-module-done__check" aria-hidden="true"><Icon name="check" size=12 weight=3/></span>
        <span class="ll-module-done__can">${scene.canDo || scene.title}</span>
      </li>
    </for>
  </ul>

  <if=m.grammar.length>
    <h2 class="ll-module-done__head">${copy.grammarPointsCount}</h2>
    <ul class="ll-module-done__chips">
      <for|point| of=m.grammar><li>${point}</li></for>
    </ul>
  </if>

  <if=input.content>
    <div class="ll-module-done__pdf"><${input.content}/></div>
  </if>

  <div class="ll-module-done__course">
    <span>${fill(copy.moduleProgress, { n: m.n, total: m.total })}</span>
    <span class="ll-module-done__segments" aria-hidden="true">
      <for|i| from=1 to=m.total><i class=(i <= m.n && "is-done")></i></for>
    </span>
  </div>
</section>
